module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fronttitle",
    attrs: {
      "id": "heading_id_2"
    }
  }, [_vm._v("PREFACE")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("A")]), _vm._v("fter Paris was liberated in late August 1944, U.S. intelligence summaries reflected that the end of the war in Europe was within sight. Hitler's armies in the West had been shattered, Paris belonged to the French again, and Allied armies were confidently advancing to the last frontier of the European war. Many American commanders expected their troops would be home for Christmas.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Third Reich's means to continue the fight would cease when the Ruhr industrial area was destroyed. Berlin would follow. There were four ways for the Allied armies to get there: the plain of Flanders, the Ardennes, the Metz-Kaiserslauten gap, or the Maubeuge-Leige-Aachen axis north of the Ardennes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On 5 September, Gen. Dwight D. Eisenhower made a fateful decision. He dictated a memorandum to his secretary stating that the American armies would advance rapidly on the Ruhr by pushing through the "), _c('i', [_vm._v("Westwall")]), _vm._v(" directly to the north and south of Aachen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Within days the eyes of all Germans, both military and civilian, were on the fate of the ancient imperial city. Rapidly closing on the border were four U.S. divisions, arguably amongst America's finest. North of Aachen were the 30th Infantry Division, veterans of vicious fighting at Mortain where the main hopes of the German army were first shattered in the West, and the combat commands of “Hell on Wheels,” the 2nd Armored Division.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Heading for the Stolberg Corridor south of Aachen was the 1st Infantry Division, experienced from fighting in North Africa, Sicily, and the beaches of Normandy; the “Big Red One” had led the Saint-Lô Breakout from the Normandy hedgerows in late July and was now being escorted to the German border by the 3rd Armored Division, the battering ram that had collapsed the southern anchor of the Falaise Gap and "), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _vm._v("trapped thousands of German forces attempting to retreat pell-mell back to the Reich.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is the continuing story of those American divisions and the opponents they faced at the "), _c('i', [_vm._v("Westwall")]), _vm._v(" of Germany. It lasts five long weeks during the fight for Aachen, a period that irrevocably changed the timetable for the end of World War II in Europe.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51c321b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/preface.vue
// module id = 66
// module chunks = 0